export interface VmDetectionResult {
    isLikelyVm: boolean;
    renderer: string;
    vendor: string;
    reason?: string;
}

/**
 * Detecta si el navegador se está ejecutando dentro de una máquina virtual (VirtualBox, VMware, etc.)
 * a través de las extensiones de depuración de WebGL y características del hardware expuestas.
 */
export const detectVirtualMachine = (): VmDetectionResult => {
    try {
        const canvas = document.createElement('canvas');
        const gl = (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')) as WebGLRenderingContext | null;

        if (!gl) {
            return {
                isLikelyVm: false,
                renderer: 'no-webgl',
                vendor: 'no-webgl'
            };
        }

        const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        const renderer = debugInfo ? (gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) || '') : (gl.getParameter(gl.RENDERER) || '');
        const vendor = debugInfo ? (gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL) || '') : (gl.getParameter(gl.VENDOR) || '');

        const rLower = String(renderer).toLowerCase();
        const vLower = String(vendor).toLowerCase();

        // Firmas características de adaptadores virtuales y software rasterizers
        const vmSignatures = [
            'virtualbox',
            'vbox',
            'vmware',
            'llvmpipe',
            'mesa dri',
            'virgl',
            'qemu',
            'parallels',
            'red hat',
            'bochs',
            'software rasterizer',
            'swiftshader'
        ];

        for (const sig of vmSignatures) {
            if (rLower.includes(sig) || vLower.includes(sig)) {
                return {
                    isLikelyVm: true,
                    renderer,
                    vendor,
                    reason: `Driver virtual detectado: "${sig}"`
                };
            }
        }

        return {
            isLikelyVm: false,
            renderer,
            vendor
        };
    } catch (err: any) {
        return {
            isLikelyVm: false,
            renderer: 'error',
            vendor: 'error',
            reason: err?.message
        };
    }
};

